import { useEffect } from 'react';

export function useScrollAteTopo() {
  function scrollarAteOTopo() {
    return document.body.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }

  useEffect(() => {
    if (!document || !document.body) return;
    scrollarAteOTopo();
  }, []);

  return { scrollarAteOTopo };
}
